import type { ClientsTranslations } from "../interfaces/clients";

export const clientsTranslations: ClientsTranslations = {
  page_title: "Clientes",
  page_subtitle: "Gestiona las organizaciones, sus clientes y el estado de verificación de identidad.",
  button_refresh: "Actualizar",
  page_loading: "Cargando clientes...",
  filters_heading: "Filtros",
  filters_label_client_type: "Tipo de cliente",
  filters_placeholder_client_type: "Seleccionar tipo cliente",
  filters_label_kyc_status: "Estado KYC",
  filters_placeholder_kyc_status: "Seleccionar estado",
  filters_label_country: "País",
  filters_placeholder_country: "Seleccionar país",
  filters_label_search: "Buscar por nombre",
  filters_placeholder_search: "Buscar por nombre...",
  filters_hint: 'Los filtros se aplican al hacer clic en "Aplicar filtros".',
  filters_button_apply: "Aplicar filtros",
  filters_button_clear: "Limpiar filtros",
  table_showing_one: "Mostrando 1 de {{total}}",
  table_showing_many: "Mostrando {{count}} de {{total}}",
  table_show_label: "Mostrar",
  table_th_type: "Tipo",
  table_th_name: "Nombre",
  table_th_email: "Email",
  table_th_country: "País",
  table_th_kyc: "KYC",
  table_th_created: "Creado",
  table_th_actions: "Acciones",
  table_empty: "No hay registros.",
  table_type_individual: "Individual",
  table_type_empresa: "Empresa",
  type_b2c: "B2C",
  type_b2b: "B2B",
  type_b2b2c: "B2B2C",
  kyc_pending: "Pendiente",
  kyc_in_review: "En revisión",
  kyc_verified: "Verificado",
  kyc_rejected: "Rechazado",
  kyc_expired: "Expirado",
  pagination_records: "Registros del {{from}} al {{to}} de {{total}}",
  pagination_total_pages: "Total de páginas ({{lastPage}})",
  pagination_first_page: "Primera página",
  pagination_prev_page: "Página anterior",
  pagination_next_page: "Página siguiente",
  pagination_last_page: "Última página",

  button_create_client: "Crear cliente",
  button_create_organization: "Crear organización",
  modal_create_title: "Crear cliente",
  modal_create_organization_title: "Crear organización",
  modal_label_parent_organization: "Organización",
  modal_placeholder_parent_organization: "Selecciona la organización",
  modal_label_client_type: "Tipo de cliente",
  modal_placeholder_client_type: "Seleccionar tipo cliente",
  modal_label_first_name: "Nombre",
  modal_placeholder_first_name: "Ej. Juan",
  modal_label_last_name: "Apellido",
  modal_placeholder_last_name: "Ej. Pérez",
  modal_label_company_name: "Razón social",
  modal_placeholder_company_name: "Ej. Acme S.A.",
  modal_label_email: "Correo electrónico",
  modal_placeholder_email: "Ej. correo@ejemplo.com",
  modal_label_phone: "Teléfono",
  modal_placeholder_phone: "Ej. +57 300 123 4567",
  modal_label_phone_dial: "Indicativo",
  modal_placeholder_phone_dial: "Selecciona país",
  modal_label_phone_national: "Número",
  modal_placeholder_phone_national: "Solo el número local sin espacios",
  modal_label_country: "País",
  modal_placeholder_country: "Seleccionar país",
  modal_label_identification_type: "Tipo de documento",
  modal_placeholder_identification_type: "Seleccionar tipo",
  modal_label_identification_number: "Número de documento",
  modal_placeholder_identification_number: "Ej. 123456789",
  modal_cancel: "Cancelar",
  modal_create_button: "Crear",
  modal_creating: "Creando...",
  modal_close_aria: "Cerrar",
  toast_create_client_success: "Cliente creado correctamente.",
  toast_create_organization_success: "Organización creada correctamente.",
  toast_create_client_duplicate: "Este cliente ya existe en esta organización.",
  validation_client_type_required: "El tipo de cliente es obligatorio.",
  validation_first_name_required: "El nombre es obligatorio.",
  validation_last_name_required: "El apellido es obligatorio.",
  validation_company_name_required: "La razón social es obligatoria.",
  validation_company_name_max: "Máximo 200 caracteres.",
  validation_company_name_min: "Mínimo 2 caracteres.",
  validation_name_letters_only: "Solo se permiten letras, espacios, apóstrofes y guiones.",
  validation_email_required: "El correo electrónico es obligatorio.",
  validation_email_invalid: "Ingresa un correo válido.",
  validation_phone_required: "El teléfono es obligatorio.",
  validation_phone_dial_required: "Selecciona el indicativo del país.",
  validation_country_required: "El país es obligatorio.",
  validation_identification_type_required: "El tipo de documento es obligatorio.",
  validation_identification_number_required: "El número de documento es obligatorio.",
  validation_first_name_max: "Máximo 120 caracteres.",
  validation_last_name_max: "Máximo 120 caracteres.",
  validation_email_max: "Máximo 255 caracteres.",
  validation_phone_max: "Máximo 30 caracteres.",
  validation_identification_type_max: "Máximo 50 caracteres.",
  validation_identification_number_max: "Máximo 100 caracteres.",

  action_view: "Ver",
  action_accounts_aria: "Cuentas del cliente",
  accounts_modal_title: "Cuentas — {{name}}",
  accounts_loading: "Cargando cuentas...",
  accounts_error_load: "No se pudieron cargar las cuentas.",
  accounts_empty: "Este cliente no tiene cuentas registradas.",
  accounts_section_list: "Cuentas registradas",
  accounts_section_new: "Registrar cuenta",
  accounts_btn_create: "Guardar cuenta",
  accounts_created_at: "Alta",
  accounts_payment_method_bank: "Banco",
  accounts_payment_method_crypto: "Wallet cripto",
  accounts_payment_method_binance_pay: "Binance Pay",
  accounts_deleted: "Eliminada",
  accounts_toast_success: "Cuenta registrada correctamente.",
  accounts_toast_error: "No se pudo registrar la cuenta.",
  accounts_validation_currency: "Selecciona una moneda.",
  accounts_validation_bank: "Selecciona un banco o método.",
  accounts_validation_payment_method: "Selecciona un método de pago.",
  accounts_field_alias_label: "Alias de la cuenta",
  accounts_field_alias_placeholder: "Ej.: Cuenta principal BRL",
  accounts_validation_alias_max: "Máximo 255 caracteres.",
  accounts_btn_delete: "Eliminar",
  accounts_delete_section_heading: "Cuenta a eliminar",
  accounts_delete_no_metadata: "Sin información adicional",
  accounts_delete_confirm_title: "Eliminar cuenta",
  accounts_delete_confirm_message:
    "¿Estás seguro de que deseas eliminar esta cuenta? Esta acción no se puede deshacer.",
  accounts_delete_final_confirm_title: "Confirmar eliminación",
  accounts_delete_final_confirm_message:
    "Por favor confirma nuevamente. La cuenta será eliminada de forma permanente al continuar.",
  accounts_delete_cancel: "Cancelar",
  accounts_delete_confirm: "Eliminar",
  accounts_delete_final_confirm_button: "Sí, eliminar cuenta",
  accounts_toast_delete_success: "Cuenta eliminada correctamente.",
  accounts_toast_delete_error: "No se pudo eliminar la cuenta.",
  view_modal_title: "Gestión KYC - {{name}}",
  view_label_name: "Nombre",
  view_label_type: "Tipo",
  view_label_email: "Email",
  view_label_country: "País",
  view_label_phone: "Teléfono",
  view_label_registration_date: "Fecha registro",
  view_btn_generate_link: "Generar verificación",
  view_btn_send_email: "Enviar por email",
  view_toast_send_email_success: "Correo de verificación KYC enviado.",
  view_toast_send_email_error: "No se pudo enviar el correo de verificación.",
  view_loading: "Cargando cliente...",
  view_error: "No se pudo cargar el cliente.",
  view_volver_cliente_padre: "Volver al cliente padre",

  view_btn_delete_client: "Eliminar cliente",
  view_delete_client_confirm_title: "Eliminar cliente",
  view_delete_client_confirm_message:
    '¿Estás seguro de que deseas eliminar al cliente "{{name}}"? Esta acción no se puede deshacer.',
  view_delete_client_section_heading: "Cliente a eliminar",
  view_delete_client_final_confirm_title: "Confirmar eliminación",
  view_delete_client_final_confirm_message:
    'Por favor confirma nuevamente. El cliente "{{name}}" será eliminado de forma permanente al continuar.',
  view_delete_client_cancel: "Cancelar",
  view_delete_client_confirm: "Eliminar",
  view_delete_client_final_confirm_button: "Sí, eliminar",
  view_toast_delete_client_success: "Cliente eliminado correctamente.",
  view_toast_delete_client_error: "No se pudo eliminar el cliente.",
  view_delete_client_blocked_one:
    "Este cliente tiene 1 cuenta bancaria registrada. Elimínala para poder continuar.",
  view_delete_client_blocked_many:
    "Este cliente tiene {{count}} cuentas bancarias registradas. Elimínalas para poder continuar.",
  view_delete_client_blocked_action: "Ver cuentas bancarias",

  view_btn_delete_organization: "Eliminar organización",
  view_delete_organization_confirm_title: "Eliminar organización",
  view_delete_organization_confirm_message:
    '¿Estás seguro de que deseas eliminar la organización "{{name}}"? Se perderá el acceso a sus clientes y cuentas. Esta acción no se puede deshacer.',
  view_delete_organization_section_heading: "Organización a eliminar",
  view_delete_organization_final_confirm_title: "Confirmar eliminación",
  view_delete_organization_final_confirm_message:
    'Por favor confirma nuevamente. La organización "{{name}}" será eliminada de forma permanente al continuar.',
  view_toast_delete_organization_success: "Organización eliminada correctamente.",
  view_toast_delete_organization_error: "No se pudo eliminar la organización.",
  view_delete_field_country: "País",
  view_delete_field_phone: "Tel.",
  view_danger_zone_action_delete: "Eliminar",

  action_edit: "Editar cliente",
  edit_modal_title: "Editar cliente",
  edit_modal_description: "Actualiza la información del cliente.",
  edit_loading: "Cargando datos del cliente...",
  edit_error_load: "No se pudieron cargar los datos del cliente.",
  edit_field_type_label: "Tipo de cliente",
  edit_field_type_individual: "Individual",
  edit_field_type_business: "Empresa",
  edit_submit_button: "Guardar cambios",
  edit_submitting: "Guardando...",
  edit_no_changes: "No hay cambios para guardar.",
  edit_toast_success: "Cliente actualizado correctamente.",
  edit_toast_error: "No se pudo actualizar el cliente.",

  edit_org_modal_title: "Editar organización",
  edit_org_modal_description: "Actualiza la información de la organización.",
  edit_org_label_name: "Nombre de la organización",
  edit_org_placeholder_name: "Ej. Acme S.A.",
  edit_org_toast_success: "Organización actualizada correctamente.",
  edit_org_toast_error: "No se pudo actualizar la organización.",
  validation_org_name_required: "El nombre de la organización es obligatorio.",
  validation_org_name_min: "Mínimo 2 caracteres.",
  validation_org_name_max: "Máximo 255 caracteres.",

  // Create client: identity (KYC) fields — Slice 3
  modal_section_company: "Datos de la empresa",
  modal_section_owner: "Datos del propietario",
  modal_label_birthdate: "Fecha de nacimiento",
  modal_placeholder_birthdate: "AAAA-MM-DD",
  modal_label_gender: "Género",
  modal_placeholder_gender: "Seleccionar género",
  gender_male: "Masculino",
  gender_female: "Femenino",
  gender_other: "Otro",
  modal_label_nationality: "Nacionalidad",
  modal_placeholder_nationality: "Seleccionar país",
  modal_label_id_country: "País del documento",
  modal_placeholder_id_country: "Seleccionar país",
  modal_label_legal_name: "Razón social",
  modal_placeholder_legal_name: "Ej. Acme S.A.",
  modal_label_business_type: "Tipo de empresa",
  modal_placeholder_business_type: "Ej. S.A.S.",
  modal_label_incorporation_date: "Fecha de constitución",
  modal_placeholder_incorporation_date: "AAAA-MM-DD",
  modal_label_owner_name: "Nombre del propietario",
  modal_placeholder_owner_name: "Ej. Jane Smith",
  modal_label_owner_country_code: "País del propietario",
  modal_placeholder_owner_country_code: "Seleccionar país",
  modal_label_owner_id_type: "Tipo de documento del propietario",
  modal_placeholder_owner_id_type: "Seleccionar tipo",
  modal_label_owner_id_number: "Número de documento del propietario",
  modal_placeholder_owner_id_number: "Ej. 123456789",
  modal_label_owner_address_line1: "Dirección del propietario",
  modal_placeholder_owner_address_line1: "Ej. Cra 7 #8-9",
  modal_label_owner_city: "Ciudad del propietario",
  modal_placeholder_owner_city: "Ej. Bogotá",
  modal_label_owner_state: "Departamento / Estado del propietario",
  modal_placeholder_owner_state: "Ej. Cundinamarca",
  modal_label_owner_postal_code: "Código postal del propietario",
  modal_placeholder_owner_postal_code: "Ej. 110111",
  doc_type_nit: "NIT",
  doc_type_cc: "CC",
  doc_type_ce: "CE",
  doc_type_ppt: "PPT",
  doc_type_passport: "Pasaporte",
  doc_type_dni: "DNI",
  doc_type_le: "LE",
  doc_type_lc: "LC",
  doc_type_ci: "CI",
  doc_type_cuil: "CUIL",
  doc_type_rg: "RG",
  doc_type_cnh: "CNH",
  doc_type_cpf: "CPF",
  doc_type_cnpj: "CNPJ",
  doc_type_rut: "RUT",
  doc_type_ine: "INE",
  doc_type_rfc: "RFC",
  doc_type_ruc: "RUC",
  doc_type_national_id: "Documento nacional de identidad",
  doc_type_driver_license: "Licencia de conducir",
  doc_type_residence_permit: "Permiso de residencia",
  doc_type_tax_id: "Identificación tributaria",
  validation_birthdate_required: "La fecha de nacimiento es obligatoria.",
  validation_birthdate_invalid: "Ingresa una fecha válida (AAAA-MM-DD).",
  validation_cpf_digits: "El CPF debe tener 11 dígitos.",
  validation_cnpj_length: "El CNPJ debe tener 14 caracteres.",
  validation_gender_required: "El género es obligatorio.",
  validation_id_country_required: "El país del documento es obligatorio.",
  validation_legal_name_required: "La razón social es obligatoria.",
  validation_legal_name_max: "Máximo 255 caracteres.",
  validation_business_type_required: "El tipo de empresa es obligatorio.",
  validation_business_type_max: "Máximo 100 caracteres.",
  validation_incorporation_date_required: "La fecha de constitución es obligatoria.",
  validation_incorporation_date_invalid: "Ingresa una fecha válida (AAAA-MM-DD).",
  validation_owner_name_required: "El nombre del propietario es obligatorio.",
  validation_owner_country_code_required: "El país del propietario es obligatorio.",
  validation_owner_id_type_required: "El tipo de documento del propietario es obligatorio.",
  validation_owner_id_number_required: "El número de documento del propietario es obligatorio.",
  validation_owner_address_line1_required: "La dirección del propietario es obligatoria.",
  validation_owner_city_required: "La ciudad del propietario es obligatoria.",
  validation_owner_state_required: "El departamento / estado del propietario es obligatorio.",
  validation_owner_postal_code_required: "El código postal del propietario es obligatorio.",
  coming_soon: "Próximamente",
  kpi_total_organizations: "Total de organizaciones",
  kpi_total_clients: "Total de clientes",
  kpi_total_meta: "Resultado de la consulta actual",
  kpi_verified: "Verificados (KYC)",
  kpi_pending_review: "Pendientes / En revisión",
  kpi_rejected_expired: "Rechazados o expirados",
  filters_option_all: "Todos",
  filters_search_organizations_placeholder: "Buscar por nombre o email de la organización…",
  filters_search_clients_placeholder: "Buscar por nombre, email o identificación…",
  filters_verified_only: "Solo verificados",
  filters_chip_search: "Búsqueda",
  filters_chip_type: "Tipo",
  filters_chip_country: "País",
  filters_chip_remove: "Quitar filtro {{label}}: {{value}}",
  filters_clear_all: "Limpiar todo",
  orgs_th_organization: "Organización",
  orgs_th_clients: "Clientes",
  orgs_th_accounts: "Cuentas",
  orgs_th_created: "Creada",
  orgs_count_clients: "clientes",
  orgs_count_accounts: "cuentas",
  orgs_action_view_clients: "Ver clientes",
  orgs_pagination_summary: "Mostrando {{from}}–{{to}} de {{total}} organizaciones",
  clients_pagination_summary: "Mostrando {{from}}–{{to}} de {{total}} clientes",
  pagination_show_label: "Mostrar",
  empty_no_results_title: "No encontramos resultados con estos filtros",
  empty_no_results_description: "Prueba ajustar la búsqueda o quitar algunos filtros activos.",
  empty_organizations_title: "Aún no hay organizaciones",
  empty_organizations_description: "Crea la primera organización para empezar a gestionar clientes.",
  empty_clients_title: "Aún no hay clientes",
  empty_clients_description: "Crea el primer cliente de esta organización para empezar a operar.",
  error_retry: "Reintentar",
  drilldown_back: "Volver",
  drilldown_accounts: "Cuentas",
  drilldown_edit_organization: "Editar organización",
  wizard_step_type: "Tipo",
  wizard_step_identity: "Identidad",
  wizard_step_details: "Datos",
  wizard_step_verify: "Verificar",
  wizard_step_company: "Datos de la empresa",
  wizard_step_contact: "Contacto y marca",
  wizard_step_owner: "Representante legal",
  wizard_progress_aria: "Progreso del asistente",
  wizard_back: "Atrás",
  wizard_continue: "Continuar",
  button_create_new: "Crear nuevo",
  modal_create_entity_title: "Crear nuevo",
  choice_entity_description: "Selecciona qué quieres registrar.",
  choice_card_organization_title: "Organización",
  choice_card_organization_description: "Registra un cliente empresarial y obtén su enlace de verificación.",
  choice_card_client_title: "Cliente",
  choice_card_client_description: "Registra una persona o empresa bajo una organización.",
  drawer_client_description: "Elige el tipo de cliente.",
  drawer_client_individual_description: "Datos de identidad del individuo.",
  client_type_card_individual_description: "Una persona natural.",
  client_type_card_business_description: "Una empresa o entidad legal.",
  org_success_title: "Organización creada",
  org_success_subtitle: "Comparte el enlace de verificación.",
  org_success_text: "{{name}} se creó correctamente y su identidad quedó registrada.",
  org_success_kyc_pending:
    "La verificación de identidad (KYC) se inició automáticamente. El estado se actualizará cuando el proceso avance.",
  org_success_done: "Listo",
  wizard_step_account: "Cuenta",
  client_success_title: "Cliente registrado",
  client_success_subtitle: "Comparte el enlace de verificación.",
  client_success_subtitle_account: "Comparte el enlace de verificación y agrega una cuenta si lo necesitas.",
  client_success_text: "{{name}} se registró correctamente y su identidad quedó registrada.",
  client_success_kyc_pending:
    "La verificación de identidad (KYC) quedó pendiente. Puedes generar el enlace más tarde desde el detalle del cliente.",
  client_success_skip: "Omitir por ahora",
  client_success_account_heading: "Agregar una cuenta en {{currency}} (opcional)",
  client_success_account_hint:
    "La cuenta quedará asignada como destino de esta dispersión; podrás enviar cuando el cliente complete la verificación KYC.",
  accounts_drawer_assign_to: "La cuenta quedará asignada a {{name}}.",
  kyc_link_title: "Enlace de verificación KYC",
  kyc_link_hint: "Comparte este enlace para completar la verificación de Coloca. No lo publiques.",
  kyc_link_hint_expires: "Este enlace es válido hasta {{date}}. No lo publiques.",
  kyc_link_copy: "Copiar enlace",
  kyc_link_copied: "Copiado",
  kyc_section_eyebrow: "Verificación",
  kyc_section_title: "Verificación KYC",
  kyc_section_sub: "Estado de la verificación de identidad y enlace para completarla.",
  kyc_verified_on: "Verificación completada el {{date}}.",
  kyc_documents_heading: "Documentos",
  kyc_document_view: "Ver",
  kyc_no_link: "No hay un enlace de verificación activo para esta identidad.",
  kyc_rejection_reason: "Motivo de rechazo: {{reason}}",
  kyc_btn_regenerate: "Regenerar enlace",
  edit_identity_title: "Identidad verificada",
  edit_identity_full_name: "Nombre completo",
  edit_identity_document: "Documento",
  edit_identity_birthdate: "Fecha de nacimiento",
  edit_identity_incorporation_date: "Fecha de constitución",
  edit_identity_locked_caption:
    "Los datos de identidad están verificados y no pueden modificarse desde aquí.",
  edit_section_contact: "Datos de contacto",
};
